//core
import React from "react";
import { useTranslation } from "react-i18next";
import {Box, Button, Typography} from "@mui/material";

//styles
import { useStyles } from "./styles";

//hooks
import { useEmployees } from "../../../../../store/admin/employees/useEmployees";

interface IInviteAdminProps {
  data: any;
  onClose: (data: boolean) => void;
}

const InviteAdmin: React.FC<IInviteAdminProps> = ({data, onClose}): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { inviteAdmin } = useEmployees();

  const handleInviteAdmin = ( ) => {
    const payload = {
      admin_id: data.id,
    }

    inviteAdmin(payload);
    onClose(false);
  }

  return (
    <Box className={styles.block}>
      <Typography sx={{ mb: 3 }} variant="h6">{t("admin.employees.invite_admin_title")}</Typography>
      <Typography variant="body2">{t("admin.employees.invite_admin_text")}</Typography>
      <Box className={styles.btn__wrapper}>
        <Box className={styles.btn__block}>
          <Button
            variant="contained"
            color="secondary"
            className={styles.btn__approve}
            onClick={handleInviteAdmin}
          >
            {t("common.buttons.yes")}
          </Button>
        </Box>
        <Box className={styles.btn__block}>
          <Button
            variant="outlined"
            color="secondary"
            className={styles.btn}
            onClick={() => {onClose(false)}}
          >
            {t("common.buttons.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default InviteAdmin;
